define(function(require, exports, module) {
    'use strict';

    const _ = require('underscore');
    const config = require('config');
    const BaseView = require('../../../base.view');
    const Model = require('backbone').Model;
    const getDynamicTagValue = require('../../../../util/swiss-theme/dynamicTag.value.util');
    require('../../../../widgets/autocomplete.widget');

    module.exports = BaseView.extend({
        options: {
            template: 'customNationality',
            label: '',
            placeholder: '',
            active: true,
            isDefaultResult: true,
            elSelector: '.fn-nationality-input-text'
        },

        events: {
            'focusin .fn-nationality-input-text': 'showCountries',
            'keydown .fn-nationality-input-text': 'checkTyping',
            'focusout .fn-nationality-input-text': 'onFocusoutField'
        },

        initialize: function(options) {
            this.options.form = options.form;
            this.sortCountries();
            this.model = new Model();
        },

        getTopCountries: function() {
            const topCounties = getDynamicTagValue('TOPCITYZENSHIP')?.split(',');

            return topCounties || [];
        },

        createTopCountries: function(arr1, arr2) {
            const obj = [];
            for (let i = 0; i < arr2.length; i++) {
                for (let k = 0; k < arr1.length ; k++) {
                    if (arr2[i] === arr1[k].code) {
                        obj.push(arr1[k]);
                    }
                }
            }

            return obj;
        },

        sortCountries: function() {
            const allowedCountries = config.get('allowedCountries');
            const aReplacer = 'aza1';
            const uReplacer = 'uzuu2';
            const oReplacer = 'ozooo3';
            const ssReplacer = 'ssssss4';
            const aUmlaut = 'ä';
            const uUmlaut = 'ü';
            const oUmlaut = 'ö';
            const ssUmlaut = 'ß';
            const topCountries = this.getTopCountries();

            _.each(allowedCountries, function(el) {
                el.name = (el.name.charAt(0).toLowerCase() + el.name.slice(1))
                    .replace(aUmlaut, aReplacer)
                    .replace(uUmlaut, uReplacer)
                    .replace(oUmlaut, oReplacer)
                    .replace(ssUmlaut, ssReplacer);
            });

            allowedCountries.sort(function(a, b) {
                return a.name.localeCompare(b.name);
            });

            _.each(allowedCountries, function(el) {
                el.name = (el.name.charAt(0).toLowerCase() + el.name.slice(1))
                    .replace(aReplacer, aUmlaut)
                    .replace(uReplacer, uUmlaut)
                    .replace(oReplacer, oUmlaut)
                    .replace(ssReplacer, ssUmlaut);
            });

            _.each(allowedCountries, function(el) {
                el.name = el.name.charAt(0).toUpperCase() + el.name.slice(1);
            });

            const set = new Set();
            const topFullCountries = this.createTopCountries(allowedCountries, topCountries);
            const separator = { name: null, code: null };

            topFullCountries.forEach(function(country) {
                set.add(country);
            });

            set.add(separator);

            allowedCountries.forEach(function(country) {
                set.add(country);
            });

            this.options.allowedCountries = allowedCountries;
            this.options.defaultAllowedCountries = [...set];
        },

        showCountries: function(event) {
            if (!event.target.value) {
                this.showAllCountries();
            }
        },

        showAllCountries: function() {
            this.searchText = '';
            this.model.set({ searchResult: this.options.defaultAllowedCountries });
            const updatedResult = this.options.defaultAllowedCountries.map((item) => this.formatOutput(item));
            this.$(this.options.elSelector).autocomplete('setResult', updatedResult);
        },

        alignmentLabel: function(label) {
            const aboveClass = 'label-above';
            const isAboveLabel = label.classList.contains(aboveClass);
            isAboveLabel && label.classList.remove(aboveClass);
        },

        search: function(value) {
            this.searchText = value.toLowerCase();
            const updatedArr = this.options.allowedCountries.filter(el => el.name.toLowerCase().startsWith(this.searchText));

            this.showDropDown(updatedArr);
        },

        showDropDown: function(cached) {
            this.model.set({ searchResult: cached });

            if (Array.isArray(cached)) {
                cached = cached.map((item) => this.formatOutput(item));
            }

            this.$(this.options.elSelector).autocomplete('setResult', cached);
        },

        formatOutput: function(value) {
            const text = value.name;
            const regexp = function(str) {
                return new RegExp('(' + str.replace(/\./g, '\\.') + ')(?![^<]*>|[^<>]*<\/)', 'i');
            };
            const highlight = function(str, re) {
                return str ? str.replace(re, '<span class="highlight">$1</span>') : null;
            };

            if (Array.isArray(this.searchText)) {
                return this.searchText.map(regexp).reduce(highlight, text);
            }

            if (typeof this.searchText === 'string') {
                return highlight(text, regexp(this.searchText));
            }

            return text;
        },

        hideDropDown: function() {
            this.model.set({ isHidden: true, searchResult: [] });
            document.querySelector(this.options.elSelector) && this.$(this.options.elSelector).autocomplete('setResult', []);

            if (!this.el.querySelector('.valid')) {
                const label = this.el.querySelector('.floating-label');
                this.alignmentLabel(label);
            }
        },

        checkTyping: function(e) {
            e.code === 'Tab' && this.hideDropDown();
        },

        handleSelectItem: function(value) {
            const selectedItem = this.model.get('searchResult')[value];
            this.el.querySelector('input.fn-nationality-input-text').value = selectedItem?.name ? selectedItem.name : '';
            this.el.querySelector('input.fn-nationality-input-text').dataset.value = selectedItem?.code ? selectedItem.code : '';
            selectedItem?.code && this.options.form.validateField(this.$el.find('.fn-validate'));
            this.options.form.data();
        },

        addNextElementFocus: function(avoidLabelAlignment) {
            this.hideDropDown();
            if (this.el.nextElementSibling && this.el.nextElementSibling?.querySelector('input')) {
                const label = this.el.querySelector('.floating-label');
                !avoidLabelAlignment && label?.classList?.add('label-above');
                const input = this.el.nextElementSibling?.querySelector('input');
                const notFocusedInputFields = ['radio', 'hidden', 'checkbox'];
                if (!notFocusedInputFields.includes(input.type)) {
                    const end = input.value.length;

                    input.setSelectionRange(end, end);
                    input.focus();
                }
            }
        },

        render: function() {
            this.options.name = this.el?.closest('.fn-lookup')?.dataset?.validationType;
            this.$el.html(this.tmpl(this.options.template, this.options));
            this.$el.removeClass('fn-validate');

            this.attachWidget(this.$el.find(this.options.elSelector).autocomplete({
                className: 'customElement__autocomplete',
                isCustomElement: true,
                search: this.search.bind(this),
                onSelect: this.handleSelectItem.bind(this),
                showAll: this.showAllCountries.bind(this),
                alignmentLabel: this.alignmentLabel.bind(this),
                minLength: 1,
                visibleRows: 5,
                collapseOnSelect: false,
                collapseOnScroll: false,
                template: 'customNationalityItem'
            }));

            return this;
        },

        onFocusoutField: function(event) {
            let isFoundMatch = false;
            let avoidLabelAlignment;
            if (event.target.value !== '') {
                /* Move label to top */
                const label = this.el.querySelector('.floating-label');
                label?.classList?.add('label-above');
            }

            this.options.defaultAllowedCountries.forEach((el) => {
                if (el.name === event.target.value) {
                    isFoundMatch = el.code;
                }
            });

            if (isFoundMatch) {
                this.el.querySelector('input.fn-nationality-input-text').dataset.value = isFoundMatch;
            } else {
                event.target.value = '';
                avoidLabelAlignment = true;
                setTimeout(() => {
                    this.hideDropDown();
                }, 100);
            }
            this.addNextElementFocus(avoidLabelAlignment);
        }
    });

});
